<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('adapters.shopify'), $t('action.authorize')]"
      ></breadcrumb>
      <div class="container">
        <div class="pd20 center">
          <div style="margin-top: 50px; font-size: 24px; color: #d1d1d1">
            {{ $t("rules.buttJoint", [$t("adapters.shopify")]) }}
          </div>
          <div v-if="code == null">
            <i class="el-icon-loading" />
            <div style="color: #d1d1d1">跳转中...</div>
          </div>
        </div>
        <div class="form-footer" v-if="code != null">
          <el-button
            type="primary"
            size="medium"
            plain
            :loading="saveSubmitDing"
            @click="saveSubmit"
            >{{ $t("action.agreeAuthorize") }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import ShopifyStore from "@/api/adapterShopifyStore";
import Cookies from "@/utils/cookies";

export default {
  mixins: [page],
  components: {},
  data() {
    return {
      saveSubmitDing: false,
      code: null,
      shop: null,
    };
  },
  mounted() {},
  created() {
    const self = this;
    // console.log(
    //   Cookies.getRowId(),
    //   "===",
    //   window.location.href,
    //   "+++",
    //   Util.parseQueryString(window.location.href, "code")
    // );
    self.code = Util.parseQueryString(window.location.href, "code");
    self.shop = Util.parseQueryString(window.location.href, "shop");
    Cookies.setShopifyHrefShop(self.shop);
    Cookies.setShopifyHrefCode(self.code);
    // console.log(
    //   self.code,
    //   "====",
    //   self.shop,
    //   Cookies.getShopifyHrefShop(),
    //   Cookies.getShopifyHrefCode()
    // );
    if (self.code) {
      console.log("===111没有code");
      if (!Cookies.getToken()) {
        self.$router.push("/");
      }
    } else {
      console.log("===222shopifyInstallByNameFun");
      self.shopifyInstallByNameFun();
    }
  },

  methods: {
    shopifyInstallByNameFun() {
      const self = this;
      ShopifyStore.installByName({
        name: self.shop,
      }).then(function (res) {
        if (res.status === 200) {
          // console.log("===res.data:", res.data);
          window.open(res.data, "_self");
        } else {
          self.sysError();
        }
      });
    },
    saveSubmit() {
      const self = this;
      const obj = {
        code: self.code,
        shop: self.shop,
      };
      if (!obj.code || !obj.shop) {
        self.$message({
          message: "shopify未返回授权码，请重新点击 授权1 或 从应用市场安装",
          type: "warning",
        });
        return;
      }
      self.saveSubmitDing = true;
      ShopifyStore.accessToken(obj).then(function (res) {
        if (res.status === 200) {
          self.saveSubmitDing = false;
          self.$message({
            message: self.$t("prompt.authorizeSuccess"),
            type: "success",
          });
          self.$router.push({ name: "adapterShopifys" });
        } else {
          self.sysError();
        }
      });
    },

    // saveSubmit() {
    //   const self = this;
    //   const obj = {
    //     code: self.code,
    //   };
    //   if (!obj.code) {
    //     self.$message({
    //       message: "shopify未返回授权码，请重新点击 授权1 或退出系统重试",
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   self.saveSubmitDing = true;
    //   ShopifyStore.accessToken(Cookies.getRowId(), obj).then(function (res) {
    //     Cookies.removeRowId();
    //     if (res.status === 200) {
    //       self.saveSubmitDing = false;
    //       self.$message({
    //         message: self.$t("prompt.authorizeSuccess"),
    //         type: "success",
    //       });
    //       self.$router.push({ name: "adapterShopifys" });
    //     } else {
    //       self.sysError();
    //     }
    //   });
    // },
  },
};
</script>
<style lang="scss" scoped>
</style>